import React, {useMemo, useState} from 'react'
import {
    Badge,
    Icon,
    useDisclosure,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

import {colors, iconNames, styleConfigChakraKeys} from '../../../constants'
import Link from '../../link'
import {useIntl} from 'react-intl'
import CartDrawer from '../../cart-drawer'
import {useHistory, useLocation} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'

const CartAction = ({cart}) => {
    const intl = useIntl()
    const history = useHistory()
    const location = useLocation()
    const {buildUrl} = useMultiSite()
    const {onClose} = useDisclosure()
    const {derivedData, data: basket} = useCurrentBasket()
    const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false)
    const styles = useMultiStyleConfig(styleConfigChakraKeys.header)
    const linkType = useMemo(() => cart?.type || 'tertiary', [cart])

    const onCartClick = () => {
        if (!location.pathname.match('/cart'))
            return history.push(buildUrl('/cart'))
        setIsCartDrawerOpen(true)
        onClose()
    }

    return (
        <>
            <Link
                aria-label={intl.formatMessage(
                    {
                        id: 'header.button.assistive_msg.my_cart_with_num_items',
                        defaultMessage: 'My cart, number of items: {numItems}'
                    },
                    {numItems: derivedData?.totalItems}
                )}
                type={linkType}
                iconComponent={
                    <>
                        <Icon as={iconNames.cart} {...styles.cartIcon} />
                        {basket && derivedData?.totalItems > 0 && (
                            <Badge
                                variant="notification"
                                sx={{
                                    bg: `${colors.blackBgColor}`,
                                    color: `${colors.white}`
                                }}
                            >
                                {derivedData?.totalItems}
                            </Badge>
                        )}
                    </>
                }
                variant="unstyled"
                {...styles.icons}
                minWidth="unset"
                onClick={onCartClick}
                buttonStyles={{
                    ...styles.icons,
                    height: 'auto',
                    _hover: {
                        filter: 'brightness(0) saturate(100%) invert(99%) sepia(3%) saturate(1625%) hue-rotate(308deg) brightness(86%) contrast(85%)'
                    }
                }}
            />

            <CartDrawer
                isDrawerOpen={isCartDrawerOpen}
                onDrawerClose={() => setIsCartDrawerOpen(false)}
                type="cart"
            />
        </>
    )
}

CartAction.propTypes = {
    cart: PropTypes.object
}

export default CartAction
